import { Pipe, PipeTransform } from '@angular/core';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';

@Pipe({
  name: 'sanitizeDOM',
  standalone: true,
})
export class SanitizeDOMPipe implements PipeTransform {
  constructor(private _sanitizer: DomSanitizer) {}

  transform(v: string | undefined): SafeHtml {
    return this._sanitizer.bypassSecurityTrustHtml(v || '');
  }
}
